export const NOT_SUPPORT_SCHEME = 'notSupportScheme'
export const INVALID_CARD_NUMBER = 'invalidCardNumber'
export const INVALID_CARD_HOLDER_NAME = 'invalidCardHolderName'
export const LONG_CARD_HOLDER_NAME = 'longCardHolderName'
export const INVALID_EXPIRY_DATE = 'invalidExpiryDate'
export const INVALID_CVV = 'invalidCvv'
